// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"c49685bbc3d9fd30ab45","303":"21503e303532cbf9c7fb","495":"e300f6e1f7dc5c44ac9f"}[chunkId] + ".js";
};